// extracted by mini-css-extract-plugin
module.exports = {"solutionCategory":"ArticleCategory_solutionCategory_2KZy6"};